import Vue from "vue";
// import FastClick from 'FastClick';
import axios from "axios";
import qs from "qs";
import swal from "swal";
import to from "await-to-js";
import VueLazyload from "vue-lazyload";
import { vState, vApi, vMutations } from "@js/store.observable";

import App from "@/App.vue";
import router from "@/js/router";
import $loading from "@/js/$loading";
import neCaptchaVerify from "@js/neCaptchaVerify";
import { isDevTool } from "@/../config/config";
import loadingImg from "@img/loading.gif";

//mock 拦截ajax 模拟测试
// require('./js/mock');

//vue mixin
// require('./js/vue-mixin');
Vue.use(VueLazyload, {
  preLoad: 1.3,
  attempt: 1,
  loading: loadingImg,
  observer: true
});
Vue.use(neCaptchaVerify);
Vue.config.productionTip = !isDevTool;
Vue.prototype.$loading = $loading;
Vue.prototype.$qs = qs;
Vue.prototype.$store = { state: vState, method: vMutations, api: vApi };
Vue.config.devtools = isDevTool;
Vue.prototype.$to = to;
Vue.prototype.swal = swal;
Vue.prototype.$axios = axios;
Vue.prototype.$activity = window.activity;

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
